<template>
  <v-navigation-drawer
    :mini-variant-width="70"
    :permanent="!isMobile"
    :expand-on-hover="!isMobile"
    v-model="isMenuOpen"
    class="menu-aside"
    :style="{ height: '100%', zIndex: 15 }"
  >
    <div
      class="sidebar"
      @mouseenter="isShowingFullLogo = true"
      @mouseleave="isShowingFullLogo = false"
    >
      <img
        v-if="!isShowingFullLogo"
        :src="require('@assets/images/logo-simbolo.png')"
        alt="Avalia logo"
        class="mt-4 mx-auto d-block"
        width="44"
      />
      <img
        v-else
        :src="require('@assets/images/logo-avalia.png')"
        alt="Avalia logo"
        class="mt-4 mx-auto d-block"
        width="114"
      />

      <div
        class="mt-8 d-flex ml-3"
        :class="{ profile: !isShowingFullLogo }"
      >
        <v-avatar
          class="cursor-pointer"
          @click="$router.push('/professor/perfil')"
        >
          <v-img :src="usuario.foto" />
        </v-avatar>
        <div
          v-if="isShowingFullLogo"
          class="ml-3"
        >
          <p class="mb-0">{{ usuario.nome }}</p>
          <router-link to="/professor/perfil">Ver Perfil</router-link>
        </div>
      </div>

      <hr class="mx-4 gray-300 mt-4 mb-1" />

      <v-list class="px-2">
        <v-list-item
          v-for="(menu, i) in menus"
          :key="'menu-professor-' + i"
          @click="onClickFunction(menu)"
          class="d-flex align-center grey--text"
          :class="{
            'lista--ativa': rotaAtiva(menu.rota),
            'mb-3': menu.titulo === 'Livros',
          }"
        >
          <v-list-item-icon
            class="d-flex align-center justify-center mx-0 my-auto"
          >
            <v-img
              v-if="isIconImage(menu.icon)"
              contain
              max-width="30"
              max-height="30"
              :src="getIconSrc(menu.icon)"
            />
            <component
              v-else
              :is="menu.icon"
            />

            <div
              v-if="menu.titulo === 'Livros'"
              class="divisor mb-2"
            />
          </v-list-item-icon>

          <v-list-item-title
            class="ms-5"
            :style="{ whiteSpace: 'normal' }"
          >
            {{ menu.titulo }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>

    <!--      <v-list class="px-2" v-show="privilegio == 5">-->
    <!--        <v-list-item-->
    <!--            v-for="(menu, i) in menusConteudo"-->
    <!--            :key="'menu-conteudo-' + i"-->
    <!--            @click="clickAcaoMenu(menu)"-->
    <!--            class="white&#45;&#45;text"-->
    <!--            :class="{'lista&#45;&#45;ativa': rotaAtiva(menu.rota), 'mb-3': menu.titulo === 'Relatório das Questões'}"-->
    <!--        >-->
    <!--          <v-list-item-icon class="my-auto">-->
    <!--            &lt;!&ndash; <component :is="menu.icon" color="#fff" /> &ndash;&gt;-->
    <!--            <v-img max-width="30" max-height="30" :src="menu.icon"/>-->
    <!--            <div v-if="menu.titulo === 'Relatório das Questões'" class="divisor"></div>-->
    <!--          </v-list-item-icon>-->

    <!--          <v-list-item-title class="my-2" :style="{ whiteSpace: 'normal' }">-->
    <!--            {{ menu.titulo}}-->
    <!--          </v-list-item-title>-->
    <!--        </v-list-item>-->
    <!--      </v-list>-->

    <ModalSair
      :modal-aberto="modalSairAberto"
      @close-modal="modalSairAberto = false"
      @sair="
        modalSairAberto = false;
        $router.push('/sair');
      "
      @continuar="modalSairAberto = false"
    />
  </v-navigation-drawer>
</template>

<script>
import alerts from "@/alerts";
import ModalSair from "@/components/ModalSair.vue";

export default {
  name: "NavbarProfessor",
  props: ["toggleMenu", "modalAppAgenda", "user"],
  mixins: [alerts],
  data() {
    return {
      isMenuOpen: false,
      isShowingFullLogo: false,
      modalSairAberto: false,
      menus: [
        {
          id: 1,
          titulo: "Início Professor",
          rota: "/professor/home",
          icon: "/assets/icones/menu-home.svg",
          ordem: 1,
          status: "Ativo",
        },
        {
          id: 2,
          titulo: "Recursos Educacionais Digitais",
          rota: "/professor-gestor/recursos-educacionais",
          icon: "/assets/icones/menu-recursos-educacionais.svg",
          ordem: 2,
          status: "Ativo",
        },
        {
          id: 3,
          titulo: "Minhas Turmas",
          rota: "/professor-gestor/minhas-turmas",
          icon: "/assets/icones/menu-turmas.svg",
          ordem: 3,
          status: "Ativo",
        },
        {
          id: 4,
          titulo: "Modelagem de Avaliações e Atividades",
          rota: "/professor/verificar-criar-modelagem",
          icon: "/assets/icones/menu-modelagem.svg",
          ordem: 4,
          status: "Ativo",
        },
        {
          titulo: "Ajuda",
          icon: "/assets/icones/menu-faq.svg",
          rota: "/professor/faq",
        },
        {
          titulo: "Sair",
          icon: "/assets/icones/aluno/menu-sair.svg",
          // icon: Logout,
          rota: "sair",
          onClickFunction: () => {
            this.sair();
          },
        },
      ],
    };
  },
  methods: {
    rotaAtiva(rota) {
      return this.$route.fullPath.indexOf(rota) !== -1;
    },
    isIconImage(icon) {
      return (
        typeof icon === "string" ||
        icon instanceof String ||
        (icon && typeof icon === "object" && typeof icon.default === "string")
      );
    },
    getIconSrc(icon) {
      if (typeof icon === "string" || icon instanceof String) {
        return icon;
      }
      return icon?.default || "";
    },
    onClickFunction(menu) {
      if (menu.onClickFunction) {
        menu.onClickFunction();
      } else {
        this.clickAcaoMenu(menu);
      }
    },
    clickAcaoMenu(menu) {
      if (menu.rota == this.$router.currentRoute.path) {
        return;
      }
      if (menu.rota != "#") {
        this.$router.push(menu.rota);
      } else {
        this.modalPaginaConstrucaoAberto = true;
      }
    },

    redirectToFaq() {
      // Redirect to the '/about' route
      this.$router.push("./src/pages/professor/faqProfessor/FaqPage.vue/about");
    },

    sair() {
      this.modalSairAberto = true;
    },

    adjustModuleByEnvironmentHoraAprenderFund1() {
      if (!this.user["obra"]) {
        return;
      }
      if (this.user["obra"] != 4) {
        return;
      }

      const isNotExistSchollYear = !this.user["anos"];

      if (isNotExistSchollYear) {
        return;
      }
      const anos = ["1º ano", "2º ano", "3º ano", "4º ano", "5º ano"];
      const fundamental1 = this.user["anos"].some((item) =>
        anos.every((anoNome) => item.nome === anoNome),
      );

      if (fundamental1) {
        return;
      }

      // eslint-disable-next-line vue/no-mutating-props
      this.user.modulos = this.user.modulos
        .map((modulo) => {
          if (modulo.titulo === "Modelagem de Avaliações e Atividades") {
            return {
              ...modulo,
              titulo: "Modelagem de Atividades",
              rota: "/professor/atividade/criar",
            };
          }
          return modulo;
        })
        .filter((modulo) => modulo.titulo !== "Minhas Turmas");
    },

    adjustModuleByEnvironmentHoraAprender() {
      if (!this.user["obra"]) {
        return;
      }
      if (this.user["obra"] != 4) {
        return;
      }

      const isNotExistSchollYear = !this.user["anos"];

      if (isNotExistSchollYear) {
        return;
      }

      const kindergartenTeach = this.user["anos"].every((item) =>
        item.nome.toLowerCase().includes("grupo"),
      );

      if (kindergartenTeach) {
        return;
      }

      const ignoreModules = [
        "Meus Arquivos",
        "Álbuns de Fotos",
        "Minhas Turmas",
      ];

      // eslint-disable-next-line vue/no-mutating-props
      this.user.modulos = this.user.modulos.filter(
        ({ titulo }) => !ignoreModules.some((modulo) => modulo === titulo),
      );
    },

    adjustModuleForChildEducation() {
      const isNotExistSchollYear = !this.user["anos"];
      if (isNotExistSchollYear) {
        return;
      }

      const kindergartenTeach = this.user["anos"].every((item) =>
        item.nome.toLowerCase().includes("grupo"),
      );

      if (!kindergartenTeach) {
        return;
      }

      const ignoreModules = [
        "Meus Arquivos",
        "Álbuns de Fotos",
        "Modelagem de Avaliações e Atividades",
        "Modelagem de Atividades",
      ];

      // eslint-disable-next-line vue/no-mutating-props
      this.user.modulos = this.user.modulos.filter(
        ({ titulo }) => !ignoreModules.some((modulo) => modulo === titulo),
      );
    },
  },
  watch: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 600;
    },
    usuario() {
      return this.$store.getters["usuarioStore/user"] || this.user || {};
    },
  },
  created() {
    this.isMenuOpen = this.menuOpen;

    //  Modelagem de Avaliações e Atividades
    this.adjustModuleForChildEducation();
    this.adjustModuleByEnvironmentHoraAprender();
    this.adjustModuleByEnvironmentHoraAprenderFund1();
    // this.menus = this.user.modulos.concat(this.menus);
  },
  components: { ModalSair },
};
</script>

<style scoped lang="scss">
.v-responsive__content {
  width: unset !important;
}

.lista--ativa {
  background: #e4f1fa;
  color: #122859 !important;
  border-radius: 30px;
}

.sidebar {
  height: 90%;
}

.cursor-pointer {
  cursor: pointer;
}

.profile {
  width: 48px;
}

@media (max-width: 600px) {
  .menu-aside {
    z-index: 202;
  }
}
</style>
